import React from 'react';
import { useSelector } from 'react-redux';
import { translatePage } from '../../../../../utils/services/translate';
import BasketSummary from '../Basket';
import './styles.scss';

const PaymentLayout = ({ children, isAuthed }) => {
  const translations = useSelector(state => state.Layout.translations);
  const language = useSelector(state => state.Layout.language);

  if (!isAuthed) return null;

  return (
    <div className="container min-height-100 d-flex justify-content-center align-items-center mt-4">
    <div className="payment-container">
      <div className="payment-content ">
        <div className="row ">
          <div className="col-12 bg-light p-2 text-center mb-3 rounded text-extra-bold">
            <h3>
              {translatePage(
                translations,
                language,
                "paymentSelectionPage",
                "yourOrderh1"
              )}
            </h3>
          </div>
        </div>
        
        <BasketSummary />
        {children}
      </div>
    </div>
    </div>
  );
};

export default PaymentLayout;